import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {withAttrs} from "../common/utils.js";
import {colors, fontFamily, lineHeight} from "./theme.js";
import {Text} from "./typo.js";
export default function VariableProductConfigValues(props) {
  const {page, config = {}} = props;
  if (!page)
    return null;
  const [product] = page.content.product;
  if (product.component === "standard_product")
    return null;
  if (product.component === "model_product")
    return null;
  const {config: pageConfig} = product;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, pageConfig.filter((c) => c.component !== "size_config").map((c) => {
    if (c.component === "options_config") {
      return /* @__PURE__ */ React.createElement(VariableProductOption, {
        key: c._uid,
        config: c,
        values: config
      });
    }
    const {options} = c;
    return options.map((o) => /* @__PURE__ */ React.createElement(VariableProductOption, {
      key: o._uid,
      config: o,
      values: config
    }));
  }));
}
function VariableProductOption(props) {
  const {config, values} = props;
  const {label, key, options} = config;
  const value = values[key];
  const selected = options.find((o) => o.value === value);
  if (!selected)
    return null;
  return /* @__PURE__ */ React.createElement(ItemCol, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, label), /* @__PURE__ */ React.createElement(ItemOptionValue, null, selected.text));
}
const ItemCol = styled.div``;
const ItemOptionLabel = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: 700;
  font-size: 12px;
  line-height: ${lineHeight};
  margin-bottom: 8px;
  text-transform: uppercase;
  color: ${colors.b1};
`;
const ItemOptionValue = styled(withAttrs(Text, {as: "div"}))`
  font-family: ${fontFamily.secondary};
  font-weight: 500;
  line-height: ${lineHeight};
  font-size: 14px;
`;
